import script from "./tb_content.vue?vue&type=script&lang=ts&setup=true"
export * from "./tb_content.vue?vue&type=script&lang=ts&setup=true"

import "./tb_content.vue?vue&type=style&index=0&id=56a8569c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56a8569c"]])

export default __exports__